import {Container} from '@mantine/core'
import {createFileRoute, useNavigate} from '@tanstack/react-router'

import {useAuthContext} from '../../../auth/auth-context'
import {
    boardWindowFromSearch,
    validateDispatchSearch,
    withBoardWindow,
    withCustomerAndYard,
} from '../../../dispatch/dispatch-search'
import {DispatchWorkspace} from '../../../dispatch/dispatch-workspace'
import {ALL_YARDS, resolveBoardYard} from '../../../dispatch/yards'
import classes from './dispatch-page.module.css'

export const Route = createFileRoute('/_app/dispatch/')({
    validateSearch: validateDispatchSearch,
    component: DispatchRoute,
})

function DispatchRoute() {
    const search = Route.useSearch()
    const {customer, yard} = search
    const {user} = useAuthContext()
    const navigate = useNavigate()
    const yardId = resolveBoardYard(yard, user?.dispatchYardId)

    return (
        <Container className={classes['page']} size="xl" pb="xl" pt={0}>
            <DispatchWorkspace
                customerId={customer ?? null}
                onCustomerIdChange={(customerId) =>
                    navigate({
                        to: '/dispatch',
                        search: (previous) => withCustomerAndYard(previous, customerId, yard),
                        replace: true,
                    })
                }
                yardId={yardId}
                onYardChange={(nextYardId) =>
                    navigate({
                        to: '/dispatch',
                        search: (previous) =>
                            withCustomerAndYard(previous, customer, nextYardId ?? ALL_YARDS),
                        replace: true,
                    })
                }
                boardWindow={boardWindowFromSearch(search)}
                onBoardWindowChange={(boardWindow) =>
                    navigate({
                        to: '/dispatch',
                        search: (previous) => withBoardWindow(previous, boardWindow),
                        replace: true,
                    })
                }
            />
        </Container>
    )
}
